import React, { Component } from 'react';
import Layout from '../Components/Layout';
import './MonthlyShippingCost.css';
import axios from 'axios';

class MonthlyShippingCost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ltlShipping: '',
            groundShipping: '',
            history: [],
            loading: true,
            error: '',
            success: '',
            currentPage: 1,
            totalPages: 1,
            totalCount: 0
        };
    }

    componentDidMount() {
        this.loadShippingData();
    }

    loadShippingData = async (page = null) => {
        const { currentPage } = this.state;
        const pageToFetch = page !== null ? page : currentPage;

        try {
            const response = await axios.get(`/shipping-cost?page=${pageToFetch}`);
            if (response.data) {
                this.setState({
                    ltlShipping: response.data.ltlShipping || '',
                    groundShipping: response.data.groundShipping || '',
                    history: response.data.history || [],
                    totalCount: response.data.totalCount || 0,
                    totalPages: response.data.totalPages || 1,
                    currentPage: response.data.currentPage || 1,
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error loading shipping data:', error);
            this.setState({ loading: false });
        }
    }

    handleLTLChange = (e) => {
        this.setState({ ltlShipping: e.target.value });
    }

    handleGroundChange = (e) => {
        this.setState({ groundShipping: e.target.value });
    }

    handleCancel = () => {
        window.location.href = '/overview';
    }

    handleUpdate = async () => {
        const { ltlShipping, groundShipping } = this.state;

        // Clear previous messages
        this.setState({ error: '', success: '' });

        // Validate required fields
        if (!ltlShipping || ltlShipping === '') {
            this.setState({ error: 'LTL Shipping Cost is required' });
            return;
        }

        if (!groundShipping || groundShipping === '') {
            this.setState({ error: 'Ground Shipping Cost is required' });
            return;
        }

        try {
            const response = await axios.post('/shipping-cost/update',
                {
                    ltlShipping,
                    groundShipping
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            // Reload data to get updated history
            await this.loadShippingData();
            this.setState({ success: 'Shipping costs updated successfully', currentPage: 1 });

            // Clear success message after 3 seconds
            setTimeout(() => {
                this.setState({ success: '' });
            }, 3000);
        } catch (error) {
            console.error('Error updating shipping costs:', error);
            const errorMessage = error.response?.data?.detail || 'Failed to update shipping costs';
            this.setState({ error: errorMessage });
        }
    }

    handlePageChange = async (pageNumber) => {
        this.setState({ loading: true });
        await this.loadShippingData(pageNumber);
    }

    render() {
        const { ltlShipping, groundShipping, history, loading, error, success, currentPage, totalPages, totalCount } = this.state;

        return (
            <Layout>
                <div className="shipping-cost-container">
                    <div className="shipping-cost-header">
                        <button className="back-button" onClick={this.handleCancel}>
                            <i className="ti-arrow-left"></i> Back to Overview
                        </button>
                    </div>

                    {error && (
                        <div className="alert alert-error">
                            <i className="ti-alert-circle"></i>
                            <span>{error}</span>
                        </div>
                    )}

                    {success && (
                        <div className="alert alert-success">
                            <i className="ti-check"></i>
                            <span>{success}</span>
                        </div>
                    )}

                    <div className="shipping-cost-cards">
                        <div className="shipping-card">
                            <h3>LTL Shipping</h3>
                            <p className="card-subtitle">LTL Raw/Packaging/Capsule Shipping cost per month</p>
                            <div className="form-group">
                                <label>Average Cost/Kg ($)</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    value={ltlShipping}
                                    onChange={this.handleLTLChange}
                                    placeholder="Enter LTL shipping value"
                                />
                            </div>
                        </div>

                        <div className="shipping-card">
                            <h3>Ground Shipping</h3>
                            <p className="card-subtitle">Ground shipping cost per month</p>
                            <div className="form-group">
                                <label>Average Cost/Kg ($)</label>
                                <input
                                    type="number"
                                    step="0.0001"
                                    value={groundShipping}
                                    onChange={this.handleGroundChange}
                                    placeholder="Enter ground shipping value"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="button-group">
                        <button className="btn-update" onClick={this.handleUpdate}>Update Average Cost</button>
                    </div>

                    <div className="shipping-history">
                        <div className="history-title">Shipping History</div>
                        <p className="history-subtitle">Historical monthly shipping values</p>

                        <table className="history-table">
                            <thead>
                                <tr>
                                    <th>Last Update (Date)</th>
                                    <th>LTL Shipping</th>
                                    <th>Ground Shipping</th>
                                    <th>Modified By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="loading-cell">Loading...</td>
                                    </tr>
                                ) : history.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="no-data-cell">No history available</td>
                                    </tr>
                                ) : (
                                    history.map((record, index) => (
                                        <tr key={index}>
                                            <td>{record.date}</td>
                                            <td>{record.ltlShipping}</td>
                                            <td>{record.groundShipping}</td>
                                            <td>{record.modifiedBy}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>

                        {totalCount > 5 && (
                            <div className="pagination">
                                <button
                                    className="pagination-btn"
                                    onClick={() => this.handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    <i className="ti-angle-left"></i>
                                </button>

                                {[...Array(totalPages)].map((_, index) => (
                                    <button
                                        key={index}
                                        className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                        onClick={() => this.handlePageChange(index + 1)}
                                    >
                                        {index + 1}
                                    </button>
                                ))}

                                <button
                                    className="pagination-btn"
                                    onClick={() => this.handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    <i className="ti-angle-right"></i>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </Layout>
        );
    }
}

export default MonthlyShippingCost;
